import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/legal/privacy/page.tsx");
